import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=128b3e2b&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=128b3e2b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b3e2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128b3e2b')) {
      api.createRecord('128b3e2b', component.options)
    } else {
      api.reload('128b3e2b', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=128b3e2b&scoped=true", function () {
      api.rerender('128b3e2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/supplyCentreManagement/tradeInquire/detail.vue"
export default component.exports